import React from "react";
import { Typography, Card, CardContent, Box } from "@mui/material";
import ThumbnailImage from "../ThumbnailImage/ThumbnailImage";
import "./ContentCard.style.css";

// Reusable Content Card Component
// Props:
// - image: image URL or object with src property
// - title: main title (max 2 lines with ellipsis)
// - subtitle: subtitle text
// - onClick: click handler function
// - imageSize: size for ThumbnailImage (default: responsive)
// - borderRadius: border radius for image (default: 12)
// - className: additional CSS classes
// - style: additional inline styles
// - elevation: MUI Card elevation (default: 1)

const ContentCard = ({
  image,
  title,
  subtitle,
  onClick,
  layout = "vertical",
  //   imageSize = 250,
  borderRadius = 8,
  className = "",
  style = {},
  ...props
}) => {
  const imageSrc = typeof image === "string" ? image : image?.src;

  const handleClick = () => {
    if (onClick) onClick();
  };

  // Render vertical layout (original)
  if (layout === "vertical") {
    return (
      <Card
        className={`content-card content-card-vertical ${className}`}
        style={style}
        onClick={handleClick}
        {...props}
      >
        <div className="content-card-image-container">
          <ThumbnailImage
            src={imageSrc}
            borderRadius={borderRadius}
            style={{ width: "100%", height: "100%" }}
          />
        </div>

        <CardContent className="content-card-content">
          {title && (
            <Typography
              className="content-card-title"
              title={title} // Tooltip for full text
            >
              {title}
            </Typography>
          )}

          {subtitle && (
            <Typography
              className="content-card-subtitle"
              color="text.secondary"
            >
              {subtitle}
            </Typography>
          )}
        </CardContent>
      </Card>
    );
  }

    // Render e-book layout (book-like aspect ratio)
    if (layout === "ebook") {
      return (
        <Card
          className={`content-card content-card-ebook ${className}`}
          style={style}
          onClick={handleClick}
          {...props}
        >
          <div className="content-card-ebook-image-container">
            <ThumbnailImage
              src={imageSrc}
              borderRadius={borderRadius}
              style={{ width: "100%", height: "100%" }}
            />
          </div>
  
          <CardContent className="content-card-content">
            {title && (
              <Typography
                className="content-card-title"
                title={title} // Tooltip for full text
              >
                {title}
              </Typography>
            )}
  
            {subtitle && (
              <Typography
                className="content-card-subtitle"
                color="text.secondary"
              >
                {subtitle}
              </Typography>
            )}
          </CardContent>
        </Card>
      );
    }

  // Render horizontal layout (new)
  if (layout === "horizontal") {

    return (
      <Card
        className={`content-card content-card-horizontal ${className}`}
        style={style}
        onClick={handleClick}
        {...props}
      >
        <Box className="content-card-horizontal-container">
          <div className="content-card-horizontal-image-container">
            <ThumbnailImage
              src={imageSrc}
              borderRadius={borderRadius}
              style={{ width: "100%", height: "100%" }}
            />
          </div>
  
          <CardContent className="content-card-horizontal-content">
            {title && (
              <Typography
                className="content-card-horizontal-title"
                title={title} // Tooltip for full text
              >
                {title}
              </Typography>
            )}
  
            {subtitle && (
              <Typography
                className="content-card-horizontal-subtitle"
                color="text.secondary"
              >
                {subtitle}
              </Typography>
            )}
          </CardContent>
        </Box>
      </Card>
    );
  }

  // Default fallback to vertical
  return null;
};

export default ContentCard;
